import { Alpine, Livewire } from '../../../../vendor/livewire/livewire/dist/livewire.esm';
import googleAutocomplete from '../modules/googleAutocomplete.js';
import stripeCardInput from '../modules/stripeCardInput.js';
import stripeExpressCheckout from '../modules/stripeExpressCheckout.js';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import storefrontNotifications from '../modules/storefrontNotifications.js';

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.data('googleAutocomplete', googleAutocomplete);
Alpine.data('stripeCardInput', stripeCardInput);
Alpine.data('stripeExpressCheckout', stripeExpressCheckout);
Alpine.data('storefrontNotifications', storefrontNotifications);

Livewire.start();

// this resolves a bug with the Mobile Safari UI/WKWebView. Bug was logging many reports in Bugsnag
// https://stackoverflow.com/questions/72720387/cant-find-variable-autofillcallbackhandler
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function() {
};
